import { percentageFormatter, dollarsFormatter } from "./decimalNumFormatter";

export default function formatter({ value, fieldSuffix, event }) {
  const formatValue = function() {
    /* If user input begins with '.' -> /^\./, replace with ''
     * If user input contains non-digit except '.' -> /[^0-9.]/, replace with '' */
    const replacedVal = `${value}`.replace(/^\.|[^0-9.]/g, "");

    /* Create two capture groups, 1st -> (^[^.]*\.[^.] *).
     * This captures everything before second '.',
     * that we want as a part of input.
     *
     * 2nd -> (\.*)
     * This caputers everything beginning from second '.',
     * that we wish to discard. */
    const regExp = /(^[^.]*\.[^.]*)(\..*)/g;
    const captureArr = regExp.exec(`${replacedVal}`);
    // If the match fails, the exec() method returns null.

    if (captureArr) {
      return captureArr[1];
    }
    return replacedVal;
  };

  if (value) {
    const formattedVal = `${formatValue()}`;

    // /[0=9]/, handle case if (formattedVal === %) and discard entire value.
    if (fieldSuffix === "Percentage" && /[0-9]/.test(formattedVal)) {
      const truncatedPercentage = percentageFormatter(formattedVal);
      // Handle delete event
      if (event && event.keyCode === 8) {
        // User selects entire text in the field and presses delete
        if (window.getSelection().toString() === value) {
          return "";
        }
        // Replace the digit before % -> (\d|\.)(?=%), with ''.
        // (or)
        // Replace value containing only one digit followed by % -> (^\d%$), with ''.
        return `${formattedVal}%`.replace(/^\d%$|(\d|\.)(?=%)/g, "");
      }

      return `${truncatedPercentage}%`;
    }

    if (fieldSuffix === "PercentWDecimal" && /[0-9]/.test(value)) {
      /* If user input begins with '.' -> /^\./, replace with '0.' */
      const formattedValue = `${value}`.replace(/^\./g, "0.");

      const truncatedPercentage = dollarsFormatter(
        parseFloat(formattedValue).toFixed(2)
      );
      return `${truncatedPercentage}%`;
    }

    if (fieldSuffix === "Dollars" && /[0-9]/.test(formattedVal)) {
      const truncatedDollar = dollarsFormatter(
        parseFloat(formattedVal).toFixed(2)
      );
      // Format to inject ','
      return `$${truncatedDollar}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    if (fieldSuffix === "Units" && /[0-9]/.test(formattedVal)) {
      return Number(formattedVal).toLocaleString(undefined, {
        minimumFractionDigits: 4,
        maximumFractionDigits: 4
      });
    }

    if (fieldSuffix === "SixDecimalUnits" && /[0-9]/.test(formattedVal)) {
      return Number(formattedVal).toLocaleString(undefined, {
        minimumFractionDigits: 6,
        maximumFractionDigits: 6
      });
    }
  }
  return "";
}
